import { render, staticRenderFns } from "./OutroTemplate.vue?vue&type=template&id=c7dc7732&scoped=true&"
import script from "./OutroTemplate.vue?vue&type=script&lang=js&"
export * from "./OutroTemplate.vue?vue&type=script&lang=js&"
import style0 from "./OutroTemplate.vue?vue&type=style&index=0&id=c7dc7732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7dc7732",
  null
  
)

export default component.exports